var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('i',{staticClass:"fa-fw",class:_vm.checkIcon(_vm.icon),attrs:{"aria-hidden":"true"}},[_vm._v("\n  "+_vm._s(_vm.iconText)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }